import styled from '@emotion/styled';

const Container = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.eclipseTier1.spacing['24px'],
}));

export const S = {
  Container,
} as const;
